import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import * as lan from '../common/script/common_lan.js';
import axios from 'axios';
import { showAlert } from '../common/script/common';

export default function PaymentNext() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState('');
    const [buttonText, setButtonText] = useState('');
    const [messageText, setMessageText] = useState('');

    useEffect(() => {
        (async () => {
            if (loading){
                const params = new URLSearchParams(window.location.search);
                const orderId = params.get("orderId");
                const paymentKey = params.get("paymentKey");
                const amount = params.get("amount");
                console.log("success params: ", orderId, paymentKey, amount);
        
                const isQA = window.location.hostname.startsWith('qa-app.thekgolf.com');
                const billingHost = isQA ? 'qa-billing.thekgolf.com' : 'billing.thekgolf.com';
        
                const url = `https://${billingHost}/v3/payment/toss/capture/course`;
                
                
                const res = await axios.post(url, {orderId, paymentKey, amount}, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-thekgolf-timezone': '+09:00',
                        'x-thekgolf-language': 'ko-kr'
                    }
                });
                
                console.log("toss capture res: ", res);
                setLoading(false);
            }
        })();
    }, []);
    
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        setButtonText('결제 성공');
        setMessageText('구매해 주셔서 감사합니다. 창을 닫아 주세요.');
        
    }, [location]);

    const handleStartPayment = () => {
        // 필요한 동작 추가

    };

    return (
        <>
            <div className="login_head">
                <span></span>
            </div>
            <div id="payment-container" style={{ textAlign: 'center' }}></div>
            <div style={{
                backgroundImage: "url(" + require('../images/bg.png') + ")",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: 'calc(100vh - 60px)',
                display: 'flex',
                flexDirection: 'column',
                color: '#fff',
                textAlign: 'center',
                padding: '1.5rem',
                marginTop: '0.8rem'
            }}>
                <div style={{ flex: 0.8 }}></div>

                {/* 버튼 영역 */}
                { (
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <button
                            onClick={handleStartPayment}
                            disabled={loading}
                            style={{
                                backgroundColor: '#1D4ED8',
                                color: '#ffffff',
                                fontSize: '1.125rem',
                                padding: '0.75rem 2rem',
                                border: 'none',
                                borderRadius: '9999px',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                cursor: 'pointer'
                            }}
                        >
                            {buttonText}
                        </button>

                    </div>
                )}
                {messageText && (
                    <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                        <p
                            style={{
                                marginTop: '0.75rem',
                                whiteSpace: 'pre-wrap',
                                color: '#ffffff',
                                fontSize: '1rem',
                                lineHeight: '1.5',
                                maxWidth: '80%',
                                textAlign: 'center'
                            }}
                        >
                            {messageText}
                        </p>
                    </div>
                )}

                <div style={{flex: 0.4}}></div>
            </div>
        </>
    );
}
